import ProgramTemplateList from '@/pages/components/manage/gov/program-template/ProgramTemplateList';

export default {
    list: ProgramTemplateList,
};
